/**
 * Extended ViewController template

 var table = new TableViewController({
                 context : this, // The context to use when calling the dataRenderer and linkClickedCallback

                 htmlTable : true, // [optional, default false] Creating a real HTML table structure instead of divs.
                 rowTemplateFile : "LP_transfer_engagement_line_agent.html", // The template for each row view
                 rowStyleFile : "LP_transfer_engagement_line.css", // The style for each row view
                 sectionTemplateFile : "LP_transfer_engagement_cap_label.html", // [optional] The style for each section, applicable when there are sections
                 noDataTemplate : "LP_transfer_engagement_no_agents.html", // The template for no data to display view
                 dataRenderer : this.agentsDataRenderer, // Renderer containing the below functions for initializing rows and filtering
                 lineClicked : this.transferLineClicked, // When link clicked on the table, this function is called, on sections its up to the target to handle them.

                 onResize : {context : this, callback : callback} // [optional] When the table is resized, this callback is called.
                 modelController : this.modelController, // [optional with modelPath] The controller for the model bind
                 modelPath : "model.path", // [optional with modelController] The path to retrieve the data from
                 modelData : {}, // If we do not listen to a path, we can actually set the data for the table
                 filterView : this.view, // [optional] The view binding for filtering the table
                 supportKeysNavigation : true, // [optional] Should support keys navigation
                 focusedView : this.getFirstElement(this.LPViewMap.filterAgent) [optional] // The view to bind the key up/down/left/right events
                 lineHighlighted : // [optional] When a line is highlighted this callback is called, common use is the shortcuts table, to keep in focus as long as it is highlighted.
                 sectionsSortFunction : // [optional] sorting function for sections
                 rowsSortFunction : // [optional] sorting function for sorting items in section
                 rowsForSortingFunction : // [optional] function to get rows array to send for  rowsSortFunction if the section is not an array of items
            });

 ViewController.prototype.dataBinder = {
                 rowSelected : function(data) {
                 },
                 rowClicked : function(data,filterRelated,event) {
                 },
                 operationCanceled : function(data) {
                 },
                 rowHovered : function(data) {
                 },
                 modelDataChanged : function(data) {
                 },
                 sectionInitialized : function(data) {
                 },
                 rowInitialized : function(data) {
                 },
                 keyUp : function(event, sectionIndex, rowIndex) {
                 }
                 keyDown : function(event, sectionIndex, rowIndex) {
                 }
             };

 ViewController.prototype.dataRenderer = {
                numberOfSections: function(data) {
                    return data.length; // If the data is array, if no sections available, return 1
                },
                numberOfRowsInSection: function(data, sectionIndex) {
                    return data[sectionIndex].length; // For array of arrays.
                },
                dataForSection: function(data, sectionIndex) {
                    // The data will be injected to the section template.
                },
                dataForRowInSection: function(data, rowIndex, sectionIndex) {
                    // The data will be injected to the row template.
                },
                filterRow:function (data, filterText) {
                    // Return true if the row should be filtered, false if it should be shown
                }
 }
 *
 * User: adic
 * Date: 10/10/12
 * Time: 11:17 AM
 */
define(function (require) {

    window.lpTag = window.lpTag || {};
    var lpUtils = require('utils/lpUtils');

    var ViewController = require('web-agent-framework/ViewController');

    // todo - lose this - why should rowData sit on the window?
    var rowData = window.rowData || {};

    var TableViewController = ViewController.extend({
        ControllerName: 'TableViewController',

        LPViewMap: {
            highlightSpans: ".lpview_highlightedSpans"
        },

        LPClassesMap: {
            selectedRow: "selected",
            tableFiltered: "table_filtered"
        },

        initialize: function (constructorData) {
            this.rowIdToModel = {};
            this.sectionsIds = [];

            this.KEY_LEFT = 37;
            this.KEY_UP = 38;
            this.KEY_RIGHT = 39;
            this.KEY_DOWN = 40;
            this.KEY_ENTER = 13;
            this.KEY_SPACE = 32;
            this.KEY_ESC = 27;
            this.WAIT_FOR_ADDITIONAL_KEY_TIMEOUT = 500;
            this.ControllerName = constructorData.ControllerName || this.ControllerName;
            this.selectedSectionIndex = -1;
            this.selectedRowViewID = "";
            this.selectedRowIndex = -1;
            this.openSectionsIds = {};
            this.openSectionsFilterIds = {};
            this.isFilterInit = false;

            this.htmlTable = constructorData.htmlTable;
            this.hoverClass = constructorData.hoverClass;
            this.ignoreRowHover = constructorData.ignoreRowHover;
            this.ignoreSectionHover = constructorData.ignoreSectionHover;
            this.onResize = constructorData.onResize;
            this.filterInputView = constructorData.filterView;
            this.rowTemplateFile = constructorData.rowTemplateFile;
            this.rowTemplate = constructorData.rowTemplate;
            this.rowStyleFile = constructorData.rowStyleFile;
            this.sectionTemplateFile = constructorData.sectionTemplateFile;
            this.sectionTemplate = constructorData.sectionTemplate;
            this.lineClickedCallback = constructorData.lineClicked;
            this.sectionsSortFunction = constructorData.sectionsSortFunction;
            this.rowsSortFunction = constructorData.rowsSortFunction;
            this.rowsForSortingFunction = constructorData.rowsForSortingFunction;
            this.lineHighlightedCallback = constructorData.lineHighlighted;
            this.modelPath = constructorData.modelPath;
            this.modelData = constructorData.modelData;
            this.context = constructorData.context;
            this.noDataTemplate = constructorData.noDataTemplate;
            this.rowsPlaceholder = constructorData.rowsPlaceholder;
            this.dataRenderer = constructorData.dataRenderer;
            this.dataBinder = constructorData.dataBinder;
            this.focusedView = constructorData.focusedView || this.view;
            this.supportKeysNavigation = constructorData.supportKeysNavigation;
            this.rowSelectedCallback = constructorData.rowSelectedCallback;
            this.disableSectionsDuringFilter = typeof constructorData.disableSectionsDuringFilter !== "undefined" ? constructorData.disableSectionsDuringFilter : false;
            this.tableName = constructorData.tableName;
            this.sectionOwnerIdTag = constructorData.sectionOwnerIdTag || 'id';
            this.disableLineClick = constructorData.disableLineClick;
            this.preventSubmitByEnter = constructorData.preventSubmitByEnter;
            this.preSearch = constructorData.preSearch;
            this.postSearch = constructorData.postSearch;

            if (this.rowTemplateFile) {
                this.rowTemplate = require('web-agent-templates/' + this.rowTemplateFile); // This is only for development env
                // this.rowTemplate = lpUtils.loadResource(this.rowTemplateFile); // This is only for development env
            }
            if (this.sectionTemplateFile) {
                this.sectionTemplate = require('web-agent-templates/' + this.sectionTemplateFile); // This is only for development env
                // this.sectionTemplate = lpUtils.loadResource(this.sectionTemplateFile); // This is only for development env
            }
        },

        events: function () {
            if (this.filterInputView) {
                this.filterInputView.setAttribute('disabled', 'disabled');
            }
            if (this.visible) {
                this.bindFilterEvents(true);
            }

            if (this.supportKeysNavigation) {
                this.bindViewEvent({view : this.focusedView, DOMEvent : "keyup", callback : this.navigateKeyUp});
                this.bindViewEvent({view : this.focusedView, DOMEvent : "keydown", callback : this.navigateKeyDown});
            }

            if (this.noDataTemplate) {
                this.noDataToDisplay = this.createView({templateFile : this.noDataTemplate, styleFile : this.rowStyleFile, target : this.rowsPlaceholder});
            }

            if (!this.disableLineClick) {
                this.bindViewEvent({DOMEvent : "click", callback : this.tableClicked});
            }
            if (this.modelPath) {
                this.bindModel({modelPath : this.modelPath, callback : this.modelChanged});
            } else {
                this.modelChanged();
            }
        },

        render: function () {
            if (this.supportKeysNavigation && this.focusedView && this.focusedView.tabIndex <= 0) {
                this.focusedView.tabIndex = 1;
            }
        }
    });

    TableViewController.prototype.updateModelData = function (modelData) {
        this.modelData = modelData;
        this.modelChanged();
    };

    TableViewController.prototype.updateModelPath = function (modelPath) {
        this.unbindModel({modelPath: this.modelPath});
        this.modelPath = modelPath;
        this.modelChanged(); // We do this implicit call to make sure that in case there is no data in the new path, the modelChanged will still get called and clean the current table.
        this.bindModel({modelPath : this.modelPath, callback : this.modelChanged});
    };

    TableViewController.prototype.bindFilterEvents = function (bind) {
        var funcName = (bind ? "bindViewEvent" : "unbindViewEvent");

        if (bind) {
            this.bindFilterEvents(false); // Unbinding before rebinding.
        }

        if (this.filterInputView) {
            this[funcName]({view : this.filterInputView, DOMEvent : "keydown", callback : this.clearFilterOnKeyDown});
    //        if (this.focusedView !== this.filterInputView) { // If the focusedView & filterInputView are the same then no need for extra binding on navigating key up/down
                this[funcName]({view : this.filterInputView, DOMEvent : "keyup", callback : this.delayedFilterKeyUp});
    //        }
            this[funcName]({view : this.filterInputView, DOMEvent : "input", callback : this.delayedFilterKeyUp});

            this[funcName]({view : this.filterInputView, callback : this.handleCutPasteEvent, DOMEvent : "paste"});
            this[funcName]({view : this.filterInputView, callback : this.handleCutPasteEvent, DOMEvent : "cut"});
            this[funcName]({view : this.filterInputView, callback : this.handleCutPasteEvent, DOMEvent : "dragend"});
            this[funcName]({view : this.filterInputView, callback : this.handleCutPasteEvent, DOMEvent : "drop"});
        }
    };

    TableViewController.prototype.rowPrefix = "TABLE_ROW_ID";

    TableViewController.prototype.refreshSelected = function (notifyListeners) {
        var rowData = this.getSelectedRowData();

        if (rowData && rowData.view && !rowData.filtered) {
            this.selectRow(rowData, notifyListeners);
        } else {
            this.clearSelection();
        }
    };

    TableViewController.prototype.getSelectedRowData = function () {
        var rowData;

        if (this.selectedSectionIndex >= 0 && this.selectedSectionIndex < this.sectionsIds.length) {
            rowData = this.rowIdToModel[this.sectionsIds[this.selectedSectionIndex]];
        }
        if (rowData && this.selectedRowIndex >= 0 && this.selectedRowIndex < rowData.rowsIds.length) {
            rowData = this.rowIdToModel[rowData.rowsIds[this.selectedRowIndex]];
        }
        return rowData;
    };

    TableViewController.prototype.clearSelection = function () {
        if (this.disposed) {
            return;
        }

        var rowData;

        if (this.selectedSectionIndex >= 0) {
            rowData = this.rowIdToModel[this.sectionsIds[this.selectedSectionIndex]];
        }
        if (rowData && this.selectedRowIndex >= 0) {
            rowData = this.rowIdToModel[rowData.rowsIds[this.selectedRowIndex]];
        }

        this.selectedRowIndex = -1;
        this.selectedSectionIndex = -1;
        if (rowData && rowData.view) {
            var viewToClearSelection;

            if (this.htmlTable) {
                viewToClearSelection = rowData.view;
            } else {
                viewToClearSelection = rowData.view.firstChild;
            }

            this.removeClass(viewToClearSelection, this.LPClassesMap.selectedRow);
        } else {
            // This is a fix for LE-41188 - two lines marked in the table
            // if no view in the rowData, we look for the view element by ID
            if (this.selectedRowViewID) {
                var selectedView = document.getElementById(this.selectedRowViewID);
                if (selectedView) {
                    this.removeClass(selectedView, this.LPClassesMap.selectedRow);
                }
            }
        }

        if (this.dataBinder && typeof this.dataBinder.clearSelectionCallback === 'function') {
            this.dataBinder.clearSelectionCallback.call(this.context, rowData);
        }
    };

    TableViewController.prototype.blur = function () {
        this.focusedView.blur();
    };

    TableViewController.prototype.focus = function () {
        var that = this;
        setTimeout(function () {
            try {
                // In IE, when setting the focus on an HTML table element, the browser sets the table scroll to top by default.
                // Currently we don't have a way to prevent this behaviour and therefore we compensate by saving the scroll position
                // prior to the focus event and restoring it after.
                // Note: the glitch seen in the UI when this happens is approved by PM for now.
                var tableScrollPosition;
                if (lpUtils._isIE() && that.htmlTable && that.view.parentNode) {
                    tableScrollPosition = that.view.parentNode.scrollTop;
                }

                that.focusedView.focus();

                if (lpUtils._isIE() && that.htmlTable && that.view.parentNode) {
                    that.view.parentNode.scrollTop = tableScrollPosition;
                }
            } catch (e) {
                // logging the exception, focus might not happen if the element is not visible or enabled.
                that.logger.error("Unable to set focus to focusedView", "focus");
            }
        }, 1);
    };

    TableViewController.prototype.updateFocusedView = function (focusedView) {
        if (this.supportKeysNavigation) {
            this.unbindViewEvent({view : this.focusedView, DOMEvent : "keyup", callback : this.navigateKeyUp});
            this.unbindViewEvent({view : this.focusedView, DOMEvent : "keydown", callback : this.navigateKeyDown});
            this.bindViewEvent({view : focusedView, DOMEvent : "keyup", callback : this.navigateKeyUp});
            this.bindViewEvent({view : focusedView, DOMEvent : "keydown", callback : this.navigateKeyDown});
        }
        this.focusedView = focusedView;
    };

    TableViewController.prototype.navigateKeyUp = function (e) {
        e = e || event;
        var keyCode = e.keyCode || e.which;

        var stopKeyPopulation = false;

        switch (keyCode) {
            case this.KEY_UP:
            case this.KEY_DOWN :
            case this.KEY_LEFT :
            case this.KEY_RIGHT :
                stopKeyPopulation = true;
                break;
            case this.KEY_ESC :
                if (this.dataBinder && this.dataBinder.operationCanceled) {
                    this.dataBinder.operationCanceled.call(this.context);
                } else {
                    this.focusedView.blur();
                }
                break;
            case this.KEY_ENTER :
                if (this.selectedSectionIndex >= 0) {
                    var rowData = this.rowIdToModel[this.sectionsIds[this.selectedSectionIndex]];
                    if (this.selectedRowIndex >= 0) {
                        rowData = this.rowIdToModel[rowData.rowsIds[this.selectedRowIndex]];
                    }
                    this.rowClicked(rowData);
                    stopKeyPopulation = true;
                }
                break;
        }

        if (stopKeyPopulation) {
            this.stopPropagation(e);
            this.preventDefault(e);
            this.touchSession();
        }
    };

    TableViewController.prototype.navigateKeyDown = function (e) {
        e = e || event;
        var keyCode = e.keyCode || e.which;
        var stopKeyPopulation = false;

        switch (keyCode) {
            case this.KEY_UP : this.navigateUpOrDown(true, this.selectedSectionIndex, this.selectedRowIndex); stopKeyPopulation = true; break;
            case this.KEY_DOWN : this.navigateUpOrDown(false, this.selectedSectionIndex, this.selectedRowIndex); stopKeyPopulation = true; break;
            case this.KEY_LEFT : this.navigateLeftOrRight(true); stopKeyPopulation = true; break;
            case this.KEY_RIGHT : this.navigateLeftOrRight(false); stopKeyPopulation = true; break;
            case this.KEY_ENTER : stopKeyPopulation = true; break;
        }

        if (stopKeyPopulation) {
            this.stopPropagation(e);
            this.preventDefault(e);
            this.touchSession();
        }

        if (this.dataBinder && typeof this.dataBinder.keyDown === 'function') {
            this.dataBinder.keyDown.call(this.context, keyCode, this.selectedSectionIndex, this.selectedRowIndex);
        }
    };

    /**
     * This method has two purposes, first to notify the owner of the table upon a row/section click so the needed
     * modification in the UI will be made.
     * Second, it is to update the section view (if exists) and to load/unload the rows from that section.
     * @param data - the row/section data
     * @param filterRelated - is this method invocation was originated from a filter action
     * @param event - the MouseEvent.
     */
    TableViewController.prototype.rowClicked = function (data, filterRelated, event) {
        if (data) {
            if (data.isSection) {
                if (data.expanded) {
                    this.unloadRowsForSection(data, filterRelated);
                } else {
                    this.loadRowsForSection(data, filterRelated);
                }
                if (!data.view) { // In case the section has no view, there is no point in proceeding to call the callback
                    return;
                }
            }
            // Calling the callback only after the load/unload is mandatory here.
            // This way the view controller that passed the callback can relay on the "sectionData.expanded" value
            // to determine easily if the section open or closed.

            var callback = this.lineClickedCallback || this.dataBinder && this.dataBinder.rowClicked;
            if (callback) {
                callback.call(this.context, data, data.view, event);
            }
        }
    };

    TableViewController.prototype.navigateUpOrDown = function (upDirection, selectedSectionIndex, selectedRowIndex) {
        if (this.sectionsIds.length === 0) { // No point to navigate if there are no sections.
            return;
        }

        var previousSectionRowData = getRowData(this, selectedSectionIndex);
        var previousRowData = getRowData(this, selectedRowIndex, previousSectionRowData);
        if (upDirection) {
            navigateUp(this, previousSectionRowData, upDirection);
        } else {
            navigateDown(this, previousSectionRowData, upDirection);
        }

        function navigateUp(context, sectionData, upDirection) {
            if (selectedSectionIndex === -1 && selectedRowIndex === -1) {
                selectedSectionIndex = context.sectionsIds.length - 1;
                selectedRowIndex = context.rowIdToModel[context.sectionsIds[selectedSectionIndex]].rowsIds.length;
            }

            if (selectedSectionIndex === 0 && sectionData) {
                if ((selectedRowIndex === -1 && sectionData.view) || (selectedRowIndex === 0 && !sectionData.view)) {
                    context.refreshSelected();
                    return; // No more searches up
                }
            }

            if (selectedRowIndex >= 0) {
                selectedRowIndex--;
            } else {
                selectedSectionIndex--;
                if (selectedSectionIndex >= 0) {
                    sectionData = getRowData(context, selectedSectionIndex);
                    if (selectedSectionIndex >= 0 && sectionData.expanded) {
                        selectedRowIndex = sectionData.rowsIds.length - 1;
                    }
                } else {
                    selectedSectionIndex = 0;
                    sectionData = getRowData(context, selectedSectionIndex);
                    selectedRowIndex = sectionData.view ? -1 : 0;
                }
            }

            updateSelectedRow(context, upDirection);
        }

        function navigateDown(context, sectionData, upDirection) {
            if (sectionData && selectedSectionIndex === context.sectionsIds.length - 1) {
                if ((selectedRowIndex === sectionData.rowsIds.length - 1)) {
                    context.refreshSelected();
                    return; // No more searches up
                }
            }

            if (selectedRowIndex >= 0) {
                selectedRowIndex++;
            } else {
                if (sectionData && sectionData.expanded) {
                    selectedRowIndex++;
                } else if (!sectionData || !sectionData.expanded) {
                    selectedSectionIndex++;
                }
            }

            if (sectionData && selectedRowIndex >= sectionData.rowsIds.length) {
                if (selectedSectionIndex < context.sectionsIds.length - 1) {
                    selectedSectionIndex++;
                    selectedRowIndex = -1;
                } else {
                    selectedRowIndex--;
                }
            }

            updateSelectedRow(context, upDirection);
        }

        function updateSelectedRow(context, upDirection) {
            var newRowData = getRowData(context, selectedSectionIndex);
            newRowData = getRowData(context, selectedRowIndex, newRowData);

            if (newRowData) {
                if (previousRowData && previousRowData.view) {
                    context.removeClass(context.htmlTable ? previousRowData.view : previousRowData.view.firstChild, context.LPClassesMap.selectedRow);
                } else if (previousSectionRowData && previousSectionRowData.view) {
                    context.removeClass(context.htmlTable ? previousSectionRowData.view : previousSectionRowData.view.firstChild, context.LPClassesMap.selectedRow);
                }

                if (newRowData.view && !newRowData.filtered) {
                    if (context.supportKeysNavigation && newRowData.view.nodeType === context.elementTypes.ELEMENT) {
                        context.view.parentNode.scrollTop = getScrollTop(context.view.parentNode, newRowData.view);
                    }

                    context.selectedRowIndex = selectedRowIndex;
                    context.selectedSectionIndex = selectedSectionIndex;
                    if (context.lineHighlightedCallback) {
                        context.lineHighlightedCallback.call(context.context, newRowData.rowData);
                    }
                } else {
                    context.navigateUpOrDown(upDirection, selectedSectionIndex, selectedRowIndex);
                }
                context.refreshSelected(true);
            }

            function getScrollTop(parentView, rowView) {
                var rowHeight = rowView.offsetHeight;
                var actualRowPos = rowView.offsetTop;
                var visiblePosStart = parentView.scrollTop;
                var visibleHeight = parentView.clientHeight + parentView.scrollTop - rowHeight;
                var scrollTop = parentView.scrollTop;

                if (actualRowPos < visiblePosStart) {
                    scrollTop = actualRowPos;
                } else if (actualRowPos > visibleHeight) {
                    scrollTop = visiblePosStart + (actualRowPos - visibleHeight);
                }

                return scrollTop;
            }
        }

        function getRowData(context, index, sectionData) {
            if (!sectionData && index >= 0 && index < context.sectionsIds.length) {
                return context.rowIdToModel[context.sectionsIds[index]];
            } else if (sectionData && index >= 0 && index < sectionData.rowsIds.length) {
                return context.rowIdToModel[sectionData.rowsIds[index]];
            }

            return sectionData;
        }
    };

    TableViewController.prototype.navigateLeftOrRight = function (leftDirection) {
//    if (this.selectedSectionIndex >= 0 && this.selectedRowIndex >= 0) {
//        var newRowData = getRowData(this, this.selectedSectionIndex);
//        if (!newRowData.view) {
//            this.lineClickedCallback.call(this.context, newRowData, newRowData.view);
//        }
//    }
//
//    function getRowData(context, index, sectionData) {
//        if (!sectionData && index >= 0 && index < context.sectionsIds.length) {
//            return context.rowIdToModel[context.sectionsIds[index]];
//        } else if (sectionData && index >= 0 && index < sectionData.rowsIds.length) {
//            return context.rowIdToModel[sectionData.rowsIds[index]];
//        }
//
//        return sectionData;
//    }
    };

    TableViewController.prototype.handleCutPasteEvent = function () {
        if (this.preSearch && typeof this.preSearch === 'function') {
            this.preSearch();
        }
        var that = this;
        setTimeout(function () {
            that.filterKeyUp(0); // No KeyCode
        }, 0);
    };

    TableViewController.prototype.clearFilterOnKeyDown = function (e) {
        if (this.timeoutForFilter) {
            clearTimeout(this.timeoutForFilter);
            this.timeoutForFilter = null;
        }

        if (e.keyCode === this.KEY_ENTER) {
            this.preventDefault(e);
            this.stopPropagation(e);
            this.touchSession();
        }
    };

    TableViewController.prototype.delayedFilterKeyUp = function (e) {
        if (this.preSearch && typeof this.preSearch === 'function') {
            this.preSearch();
        }
        if (this.timeoutForFilter) {
            clearTimeout(this.timeoutForFilter);
            this.timeoutForFilter = null;
        }

        var keyCode = this.getKeyCode(e);

        if (this.supportKeysNavigation) {
            switch (keyCode) {
                case this.KEY_UP : this.navigateUpOrDown(true, this.selectedSectionIndex, this.selectedRowIndex); this.focusedView.focus(); break;
                case this.KEY_DOWN : this.navigateUpOrDown(false, this.selectedSectionIndex, this.selectedRowIndex); this.focusedView.focus(); break;
                case this.KEY_LEFT : this.navigateLeftOrRight(true); this.focusedView.focus(); break;
                case this.KEY_RIGHT : this.navigateLeftOrRight(false); this.focusedView.focus(); break;
            }
        }

        if (keyCode === this.KEY_ENTER) {
            this.filterKeyUp(keyCode);
        } else {
            var source = this.filterInputView;
            var oldSearch = source.value;
            var that = this;
            this.timeoutForFilter = setTimeout(function () {
                that.timeoutForFilter = null;
                source = that.filterInputView;
                var currentSearch = source.value;
                if (currentSearch === oldSearch) {
                    that.filterKeyUp(keyCode);
                }
            }, this.WAIT_FOR_ADDITIONAL_KEY_TIMEOUT);
        }
    };

    /**
     * Calculate the number of rows in the table, if sections hre enabled, deduct the number of sections
     * from the total number of rows to get only the 'RAW' rows count.
     * @returns {*}
     */
    TableViewController.prototype.getNumberOfRowsWithoutSections = function () {
        if (this.configuration.sectionOwnerIdTag) {
            return this.rowsCount - this.sectionsIds.length;
        }
        return this.rowsCount;
    };

    TableViewController.prototype.filterKeyUp = function (keyCode) {
        var source = this.filterInputView;
        var currentSearch = source.value;

        currentSearch = currentSearch.replace(/^\s+|\s+$/g, '');
        // If no search exists, just showing all results, and returning.
        if (!currentSearch) {
            this.clearFiltering();
            if (this.postSearch && typeof this.postSearch === 'function') {
                this.postSearch();
            }
            return;
        }

        if (currentSearch === this.previousFilterText && keyCode !== this.KEY_ENTER) { // No change in search, meaning no change in results.
            return;
        }

        this.lastVisibleRow = null;
        var visibleRows = 0;
        var subsetFilter = false;

        // If the filter is subset of the previous filter, than searching only previous results.
        if (this.previousFilterText && currentSearch && currentSearch.length > this.previousFilterText.length && currentSearch.indexOf(this.previousFilterText) === 0) {
            subsetFilter = true;
        }

        this.previousFilterText = currentSearch;
        if (this.disableSectionsDuringFilter) { // if disableSectionsDuringFilter, add class that will hide the button
            this.addClass(this.view, this.LPClassesMap.tableFiltered);
        }
        var index;
        var sectionId;
        var rowId;
        var rowsIds;
        var rowIndex;

        for (index = 0; index < this.sectionsIds.length; index++) {
            sectionId = this.sectionsIds[index];
            rowsIds = this.rowIdToModel[sectionId].rowsIds;
            var visibleRowsInSection = 0;

            var sectionData = this.rowIdToModel[sectionId];

            if (!this.isFilterInit) { // set the previousExpanded only for the first run of the filter
                sectionData.previousExpanded = sectionData.expanded || false;
            }
            for (rowIndex = 0; rowIndex < rowsIds.length; rowIndex++) {
                rowId = rowsIds[rowIndex];
                if (!this.filterRow(rowId, sectionId, subsetFilter, currentSearch)) {
                    visibleRowsInSection++;
                    visibleRows++;
                }
            }
            updateSectionVisibility(this, sectionData, visibleRowsInSection);
        }

        this.isFilterInit = true;
        postRendering(this);
        this.emitVisibleRowsChange(visibleRows);
        if (this.postSearch && typeof this.postSearch === 'function') {
            this.postSearch();
        }

        function postRendering(scope) {
            if (source.value !== '' && keyCode === scope.KEY_ENTER && scope.lastVisibleRow && visibleRows === 1) {
                if (!scope.preventSubmitByEnter) {
                    scope.rowClicked(scope.lastVisibleRow);
                    source.value = '';
                    scope.clearFiltering();
                }
            }

            if (visibleRows > 0) {
                scope.hideNoDataLabel();
            } else {
                scope.showNoDataLabel();
            }

            scope.refreshSelected();

            if (scope.onResize) {
                scope.onResize.callback.call(scope.onResize.context);
            }
        }

        function updateSectionVisibility(scope, sectionData, visibleRowsInSection) {
            if (sectionData) {
                sectionData.filtered = visibleRowsInSection === 0;
                if (sectionData.view) {
                    if (sectionData.filtered) { // If section exists and has no visible rows, filtering it.
                        scope.lpHide(sectionData.view);
                    } else {
                        scope.lpShow(sectionData.view);
                    }
                }
            }
            return sectionId;
        }
    };

    /**
     * Return the number of visible rows.
     * if filtering is enabled, return the number of visible rows by the counter, else calculating the
     * number of rows by the data.
     * @returns {*}
     */
    TableViewController.prototype.getNumOfVisibleRows = function(){
        if(typeof this.numOfVisibleRows !== 'undefined')
        {
            return this.numOfVisibleRows;
        }
        return this.getNumberOfRowsWithoutSections();
    };

    /**
     * Check if the number of visible rows is changed and emit the change event accordingly.
     * @param numOfRows
     */
    TableViewController.prototype.emitVisibleRowsChange = function (numOfRows) {
        if (this.numOfVisibleRows !== numOfRows) {
            this.numOfVisibleRows = numOfRows;

            if (this.dataBinder.visibleRowsCountChange) {
                this.dataBinder.visibleRowsCountChange.call(this.context, {
                    numOfRows: numOfRows,
                    isFiltered: !!this.previousFilterText
                });
            }
        }
    };

    TableViewController.prototype.filterRow = function (rowId, sectionId, subsetFiltering, currentSearch) {
        var rowData = this.rowIdToModel[rowId];
        var data = rowData.rowData;

        if (subsetFiltering && data.filter) {
            return true;
        }

        // Only if data exists then showing the row, no point of filtering empty sections.
        if (data) {
            var rowFiltered = this.dataRenderer.filterRow.call(this.context, data, currentSearch);
            rowData.filtered = rowFiltered;

            var rowView = rowData.view;

            if (rowFiltered) {
                if (rowView) {
                    this.lpHide(rowView);
                    // If filtering the selected row, clearing the selection
                    if (this.selectedRowIndex === rowData.viewRowIndex && this.selectedSectionIndex === rowData.viewSectionIndex) {
                        this.clearSelection();
                    }
                }
            } else {
                if (rowView) {
                    highlightTextInRow(this, rowView, rowData, currentSearch);
                    this.addClass(rowView.firstChild, "highlight_row");
                    this.lastVisibleRow = rowData;
                    this.lpShow(rowView);
                } else {
                    if (!this.isFilterInit) { // Open the section only if this is the first time the filter run
                        this.rowClicked(this.rowIdToModel[sectionId], true);
                    }
                }
                return false;
            }
        }

        return true;

        function highlightTextInRow(scope, rowView, dataObj, textToHighlight) {

            var html = scope.rowTemplate;

            textToHighlight = escapeTextForDynamicRegex(textToHighlight);

            var splitTextArray = textToHighlight.replace(/^\s+|\s+$/g, '').split(' ');
            splitTextArray = splitTextArray.sort(function (strA, strB) {
                return strB.length - strA.length;
            });

            if (textToHighlight === '') {
                return;
            }

            var data = scope.dataRenderer.dataForRowInSection.call(scope.context, scope.modelData, dataObj.rowIndex, dataObj.sectionIndex);
            var propertiesForHighlight;
            if (scope.dataRenderer.getPropertiesForHighlight) {
                propertiesForHighlight = scope.dataRenderer.getPropertiesForHighlight.call(scope.context);
            }
            var startSpan = "{{{{{{}}}";
            var endSpan = "{{{}}}}}}";

            for (var prop in data) {
                if (data.hasOwnProperty(prop) && typeof data[prop] === 'string' && (!propertiesForHighlight || propertiesForHighlight[prop])) {
                    for (var index = 0; index < splitTextArray.length; index++) {
                        var text = splitTextArray[index];
                        if (text) {
                            var replaceStr = new RegExp(text, "gi");

                            var matches = data[prop].match(replaceStr);

                            if (matches) {
                                var matchesSet = {};
                                for (var matchIndex = 0; matchIndex < matches.length; matchIndex++) {
                                    matchesSet[matches[matchIndex]] = null;
                                }
                                for (var key in matchesSet) {
                                    if (matchesSet.hasOwnProperty(key)) {
                                        var singleRegex = new RegExp(escapeTextForDynamicRegex(key), 'g');
                                        data[prop] = data[prop].replace(singleRegex, startSpan + key + endSpan);
                                    }
                                }
                            }
                        }
                    }
                }
            }

            html = scope.injectTextDefaults(html, data);
            html = html.replace(new RegExp(startSpan, "gi"), "<span class='" + scope.LPViewMap.highlightSpans.substring(1) + " highlight " + (scope.color || '') + "'>");
            html = html.replace(new RegExp(endSpan, "gi"), "</span>");

            rowView.innerHTML = html;
        }

        function escapeTextForDynamicRegex(str) {
            str = str.replace(new RegExp("/}", "g"), '\\}');
            str = str.replace(new RegExp("/{", "g"), '\\{');
            str = str.replace(/\)/g, '\\)');
            str = str.replace(/\(/g, '\\(');
            str = str.replace(/\./g, "\\.");
            str = str.replace(/\?/g, "\\?");
            str = str.replace(/\+/g, "\\+");

            return str;
        }
    };

    TableViewController.prototype.changeHighlightColor = function (color) {

        if (!color) {
            return;
        }

        var elements = this.getElements(this.LPViewMap.highlightSpans);

        if (this.color) {
            this.removeClass(this.view, this.color);
        }

        this.addClass(this.view, color);

        for (var index = 0; index < elements.length; index++) {
            if (this.color) {
                this.removeClass(elements[index], this.color);
            }
            this.addClass(elements[index], color);
        }

        this.color = color;
    };

    TableViewController.prototype.getKeyCode = function (e) {
        return e.keyCode || e.which;
    };

    TableViewController.prototype.lpShow = function (view) {
        if ((!view || view === this) && !this.visible) {
            if (this.modelPath) {
                this.unbindModel({modelPath : this.modelPath, callback : this.modelChanged});
                this.bindModel({modelPath : this.modelPath, callback : this.modelChanged});
            }

            this.bindNavigationKeyEvents();

            if (this.filterInputView) {
                this.bindFilterEvents(true);
            }
        }
        ViewController.prototype.lpShow.call(this, view);
    };

    TableViewController.prototype.lpHide = function (view) {
        if ((!view || view === this.view) && this.visible) {
            if (this.modelPath) {
                this.unbindModel({modelPath : this.modelPath, callback : this.modelChanged});
            }
//        if (this.dataBinder && this.dataBinder.tableResized) {
//            this.unbindViewEvent({DOMEvent: "resize", view: this.view, callback: this.dataBinder.tableResized});
//        }

            this.unbindNavigationKeyEvents();
            if (this.filterInputView) {
                this.bindFilterEvents(false);
            }
        }

        ViewController.prototype.lpHide.call(this, view);
    };

    TableViewController.prototype.bindNavigationKeyEvents = function () {
        if (this.supportKeysNavigation) {
            this.unbindNavigationKeyEvents(); // Unbinding to prevent dual binding
            this.bindViewEvent({view : this.focusedView, DOMEvent : "keyup", callback : this.navigateKeyUp});
            this.bindViewEvent({view : this.focusedView, DOMEvent : "keydown", callback : this.navigateKeyDown});
        }
    };

    TableViewController.prototype.unbindNavigationKeyEvents = function () {
        if (this.supportKeysNavigation) {
            this.unbindViewEvent({view : this.focusedView, DOMEvent : "keyup", callback : this.navigateKeyUp});
            this.unbindViewEvent({view : this.focusedView, DOMEvent : "keydown", callback : this.navigateKeyDown});
        }
    };

    TableViewController.prototype.hideNoDataLabel = function () {
        if (this.noDataToDisplay) {
            this.lpHide(this.noDataToDisplay);
        }
    };

    TableViewController.prototype.showNoDataLabel = function () {
        if (this.noDataToDisplay) {
            this.lpShow(this.noDataToDisplay);
        }
    };

    /**
     * Clearing filtering from filtered rows.
     */
    TableViewController.prototype.clearFiltering = function () {
        if (!this.previousFilterText) {
            return;
        }

        this.previousFilterText = null;
        this.isFilterInit = false;
        this.openSectionsFilterIds = {};
        if (this.disableSectionsDuringFilter) {
            this.removeClass(this.view, this.LPClassesMap.tableFiltered);
        }


        if (this.rowsCount && this.rowsCount > 0) {
            this.hideNoDataLabel();
            for (var index = 0; index < this.sectionsIds.length; index++) {
                var sectionData = this.rowIdToModel[this.sectionsIds[index]];

                if (sectionData.filtered) {
                    if (sectionData.view) {
                        this.lpShow(sectionData.view);
                    }
                    sectionData.filtered = undefined;
                }

                if (sectionData.expanded) {
                    this.rowClicked(sectionData, true);
                }

                if (sectionData.previousExpanded) {
                    this.rowClicked(sectionData, true);
                }
                sectionData.previousExpanded = (sectionData.view ? false : true);

                if (this.selectedRowIndex >= 0 && this.selectedSectionIndex >= 0) {
                    this.refreshSelected();
                }
            }
        } else {
            this.showNoDataLabel();
        }

        if (this.onResize) {
            this.onResize.callback.call(this.onResize.context);
        }

        this.emitVisibleRowsChange(this.getNumberOfRowsWithoutSections());


        if (this.onClearFilter) {
            this.onClearFilter.call(this.context);
        }
    };

    TableViewController.prototype.modelChanged = function () {
        if (this.modelPath) {
            this.modelData = getModelDataAsArray(this);
        }

        var fragmentDocument;

        if (this.htmlTable) {
            fragmentDocument = "";
        } else {
            fragmentDocument = document.createDocumentFragment();
        }

        var selectedRowData = this.getSelectedRowData();
        var selectedRowId;

        if (selectedRowData) {
            selectedRowId = selectedRowData.id;
        }

        var rand = Math.random();
        var addedLines = false;

        clearTable(this);
        if (this.modelData) {
            var sectionsLength = this.dataRenderer.numberOfSections ? this.dataRenderer.numberOfSections.call(this.context, this.modelData) : 1;

            this.modelData = sortModelData.call(this, sectionsLength);

            for (var secIndex = 0; secIndex < sectionsLength; secIndex++) {
                var sectionData = createSection(this, secIndex, this.modelData, fragmentDocument);

                if (sectionData) {
                    this.sectionsIds.push(sectionData.rowId);
                }

                var rowsLength = this.dataRenderer.numberOfRowsInSection.call(this.context, this.modelData, secIndex);

                var actualRowIndex = 0;
                for (var rowIndex = 0; rowIndex < rowsLength; rowIndex++) {
                    var rowData = this.dataRenderer.dataForRowInSection.call(this.context, this.modelData, rowIndex, secIndex);

                    if (rowData) {
                        rowData.rowData = rowData.rowData || this.modelData[rowIndex];
                        addedLines = true;
                        var rowId = "rowId_" + secIndex + "_" + rowIndex + "_" + rand++;
                        this.rowsCount++;
                        this.rowIdToModel[rowId] = {
                            id: rowData.id || rowId,
                            rowData: rowData.rowData,
                            isSection: false,
                            filtered: false,
                            rowIndex: rowIndex,
                            sectionIndex: secIndex,
                            viewRowIndex: actualRowIndex,
                            viewSectionIndex: secIndex};
                        actualRowIndex++;

                        sectionData.rowsIds.push(rowId);

                        if (!sectionData.view || sectionData.expanded) {
                            if (typeof selectedRowId !== 'undefined' && this.rowIdToModel[rowId].id == selectedRowId) {
                                rowData.selected = this.LPClassesMap.selectedRow;

                                this.selectedRowIndex = this.rowIdToModel[rowId].viewRowIndex;
                                this.selectedRowViewID = rowId;
                                this.selectedSectionIndex = this.rowIdToModel[rowId].viewSectionIndex;
                            }
                            else {
                                rowData.selected = "";
                            }

                            var view = sectionData.view || fragmentDocument;
                            var rowView = this.createRow(view, this, rowData, rowId);
                            if (this.htmlTable) {
                                fragmentDocument += rowView;
                            } else {
                                this.rowIdToModel[rowId].view = rowView;
                            }
                        }
                    }
                }
            }
        }

        if (addedLines) { // data exists
            this.hideNoDataLabel();

            if (this.filterInputView) {
                this.filterInputView.removeAttribute('disabled');
                this.previousFilterText = ""; //clear previous filter to force filtering on the next call to filterKeyUp()
                this.filterKeyUp();
            }
        } else {
            // This is commented out due to the case when we have more than one table that listen to the same filter field and one can be
            // is empty while the other not (TransferViewController), a code change is needed to support this.
//        if (this.filterInputView) {
//            this.filterInputView.value = "";
//            this.filterInputView.setAttribute('disabled', 'disabled');
//        }
            this.showNoDataLabel();
        }

        if (this.onResize) {
            this.onResize.callback.call(this.onResize.context);
        }

        if (this.dataBinder && this.dataBinder.modelDataChanged) {
            this.dataBinder.modelDataChanged.call(this.context, this.modelData);
        }

        if (this.htmlTable) {
            var tableBodyNode = this.rowsPlaceholder ? this.getFirstElement(this.rowsPlaceholder) : this.view;
            var newTableBodyNode = lpUtils.replaceTableNodeContent(tableBodyNode, fragmentDocument);
            // Notifying all listeners that this table was modified and passing reference to the new table node.
            if (newTableBodyNode && newTableBodyNode.parentNode) {
                this.viewEventsHandler.fireEvent({
                    appName: this.tableName,
                    UIEvent: this.viewEventsHandler.eventType.TABLE_CONTENT_CHANGED,
                    eventData: {
                        tableRef: newTableBodyNode.parentNode
                    }
                });
            }

            var context = this;
            setTimeout(function () {
                var rowId;
                for (rowId in context.rowIdToModel) {
                    if (context.rowIdToModel.hasOwnProperty(rowId)) {
                        context.rowIdToModel[rowId].view = document.getElementById(rowId);
                        if (context.dataBinder && context.dataBinder.rowChanged && !context.rowIdToModel[rowId].isSection) {
                            context.dataBinder.rowChanged.call(context.context, context.rowIdToModel[rowId]);
                        }
                    }
                }
            }, 0);
        } else {
            this.view.appendChild(fragmentDocument);
        }

        function sortModelData(sectionsLength) {
            var modelData;
            if (this.sectionsSortFunction || this.rowsSortFunction) {
                modelData = this.modelData.slice(0); // Cloning the model in order to sort the local copy and not the application model.
            } else {
                modelData = this.modelData;
            }

            if (this.sectionsSortFunction) {
                modelData.sort(this.sectionsSortFunction);
            }
            if (this.rowsSortFunction) {
                for (var i = 0; i < sectionsLength; i++) {
                    if (this.rowsForSortingFunction) {
                        var items = this.rowsForSortingFunction.call(this.context, modelData[i]);
                        if (items && items.constructor === Array) {
                            items.sort(this.rowsSortFunction);
                        }
                    } else if (modelData[i] && modelData[i].constructor === Array) {
                        modelData[i].sort(this.rowsSortFunction);
                    } else {
                        modelData.sort(this.rowsSortFunction);
                    }
                }
            }

            return modelData;
        }

        function getModelDataAsArray(context) {
            var modelData = context.modelController.getModelParam(context.modelPath); // This fixes additional values to the path instead of rendering
                                                                                      // only the new values received, assuming all values are deleted.
            if (modelData && modelData.constructor !== Array) {
                var array = [];
                for (var prop in modelData) {
                    if (modelData.hasOwnProperty(prop)) {
                        array.push({key: prop, value: modelData[prop]});
                    }
                }
                modelData = array;
            }

            return modelData;
        }

        function clearTable(scope, clearOpenSections) {

            scope.rowsCount = 0;
            scope.rowIdToModel = {};
            scope.sectionsIds = [];
            // Since we clear the table as part of the modelChanged flow we will not want to reset the openSectionIds map
            // most of the times since we would like the sections to preserve their open/close state
            if (clearOpenSections) {
                scope.openSectionsIds = {};
                scope.openSectionsFilterIds = {};
            }

            var elements = scope.getElements("." + scope.rowPrefix);

            for (var index = 0; index < elements.length; index++) {
                // Removing all the DOM Bindings if has any. (search)
                scope.unbindViewEvent({view:elements[index], DOMEvent:"mouseover", callback:scope.mouseEnterRow});
                scope.unbindViewEvent({view:elements[index], DOMEvent:"mouseout", callback:scope.mouseExitRow});
                scope.removeView(elements[index]);
            }
            elements = null;
        }

        function createSection(context, sectionIndex, modelData, target) {
            var sectionData;
            var sectionView;
            var createSectionView = false;
            var createSectionExpanded = {expanded: true, previousExpanded: true};

            if (context.dataRenderer.dataForSection) {
                sectionData = context.dataRenderer.dataForSection.call(context.context, modelData, sectionIndex);
            }
            if (sectionData) {
                createSectionView = true;
                sectionData.rowData = sectionData.rowData || context.modelData[sectionIndex];
                createSectionExpanded = isSectionExpanded(sectionData);
            } else {
                sectionData = {};
                sectionData.rowData = context.modelData;
            }

            sectionData.detailsTooltip = sectionData.detailsTooltip || "";
            sectionData.details = sectionData.details || "";
            sectionData.text = sectionData.text || "";

            var rowId = "rowId_" + sectionIndex + "_" + rand++;

            if (createSectionView) {
                sectionView = context.createView({
                    template: context.sectionTemplate,
                    styleFile: context.rowStyleFile,
                    className: context.rowPrefix,
                    elementId: rowId,
                    textInjection: sectionData,
                    target: target
                });

                if (!context.ignoreSectionHover) {
                    context.bindViewEvent({view:sectionView, DOMEvent:"mouseout", callback:context.mouseExitRow, lpEventData:{rowId:rowId}});
                    context.bindViewEvent({view:sectionView, DOMEvent:"mouseover", callback:context.mouseEnterRow, lpEventData:{rowId:rowId}});
                }

                context.rowsCount++;
            }

            context.rowIdToModel[rowId] = {
                rowData: sectionData.rowData,
                rowId: rowId,
                isSection: true,
                filtered: false,
                previousExpanded: createSectionExpanded.previousExpanded,
                expanded: createSectionExpanded.expanded,
                sectionIndex: sectionIndex,
                viewSectionIndex: sectionIndex, // TODO: View section index should be the actual section index (different than section index sometimes) [Adi 10/7/2013]
                rowsIds: [],
                view: sectionView
            };

            if (context.dataBinder && context.dataBinder.sectionInitialized) {
                context.dataBinder.sectionInitialized.call(context.context, context.rowIdToModel[rowId]);
            }

            return context.rowIdToModel[rowId];

            function isSectionExpanded(sectionData) {
                // Override the user default decision in case this section has a previous open/close state
                var returnArray = {expanded: true, previousExpanded: true};
                var sectionOwnerId = context.getSectionOwnerId(sectionData.rowData);
                if (typeof sectionOwnerId !== "undefined") {
                    // get the expanded status
                    var openSectionsId = context.isFilterInit ? context.openSectionsFilterIds[sectionOwnerId] : context.openSectionsIds[sectionOwnerId];
                    if (typeof openSectionsId !== "undefined") {
                        sectionData.selected = openSectionsId;
                    } else if (context.isFilterInit) { // if getting undefined and it on filter state, it's a new data that need to be open
                        sectionData.selected = true;
                    }
                    // get the previousExpanded status
                    if (typeof context.openSectionsIds[sectionOwnerId] !== "undefined") {
                        returnArray.previousExpanded = context.openSectionsIds[sectionOwnerId];
                    }
                }
                sectionData.selected = sectionData.selected ? context.LPClassesMap.selectedRow : "";
                returnArray.expanded = !!sectionData.selected;
                return returnArray;
            }
        }
    };

    TableViewController.prototype.tableClicked = function (e) {
        var target = e.sourceElement;

        if (!target || target.href) {
            return;
        }

        var view = target;
        while (view && view !== this.view && !this.hasAtLeastOneClass(view, this.rowPrefix)) {
            view = view.parentNode;
        }

        if (view && view !== this.view) {
            var data = this.rowIdToModel[view.id];
            if (data) {
                if (data.isSection && this.previousFilterText && this.disableSectionsDuringFilter) {
                    return;
                }
                this.rowClicked(data, undefined, e);
                if (!data.isSection) {
                    this.selectRow(data, undefined, e);
                }
            }
        }

        this.stopPropagation(e);
        this.preventDefault(e);
        this.touchSession();
        view = null;
        target = null;
    };

    TableViewController.prototype.unloadRowsForSection = function (data, filterRelated) {
        if (!data.isSection || !data.expanded) {
            return; // No-Op on rows or sections with unloaded rows.
        }
        data.expanded = false;
        if (!filterRelated) {
            var sectionOwnerId = this.getSectionOwnerId(data.rowData);
            if (typeof sectionOwnerId !== "undefined") {
                var openSectionsIdArray = this.isFilterInit ? this.openSectionsFilterIds : this.openSectionsIds;
                openSectionsIdArray[sectionOwnerId] = false;
            }
        }
        for (var index = 0; index < data.rowsIds.length; index++) {
            var view = this.rowIdToModel[data.rowsIds[index]].view;
            if (view) {
                this.unbindViewEvent({view:view, DOMEvent:"mouseover", callback:this.mouseEnterRow});
                this.unbindViewEvent({view:view, DOMEvent:"mouseout", callback:this.mouseExitRow});

                view.parentNode.removeChild(view);
                this.rowIdToModel[data.rowsIds[index]].view = null;
                delete this.rowIdToModel[data.rowsIds[index]].view;
            }
        }
    };

    TableViewController.prototype.loadRowsForSectionByRowId = function (rowId) {
        var data = this.rowIdToModel[rowId];
        if (data && !data.expanded) {
            this.rowClicked(data);
        }
    };

    TableViewController.prototype.loadRowsForSection = function (data, filterRelated) {
        if (!data.isSection || data.expanded) {
            return; // No-Op on rows or sections with unloaded rows.
        }

        data.expanded = true;
        if (!filterRelated) {
            var sectionOwnerId = this.getSectionOwnerId(data.rowData);
            if (typeof sectionOwnerId !== "undefined") {
                var openSectionsIdArray = this.isFilterInit ? this.openSectionsFilterIds : this.openSectionsIds;
                openSectionsIdArray[sectionOwnerId] = true;
            }
        }
        var rowsLength = data.rowsIds.length;
        for (var rowIndex = 0; rowIndex < rowsLength; rowIndex++) {
            var rowId = data.rowsIds[rowIndex];
            var rowData = this.rowIdToModel[rowId];
            if (rowData) {
                rowData.filtered = false;
                var injectionText = this.dataRenderer.dataForRowInSection.call(this.context, this.modelData, rowData.rowIndex, rowData.sectionIndex);
                this.createRow(data.view || this.view, this, injectionText, rowId);
                if (this.previousFilterText) {
                    this.filterRow(rowId, data.rowId, false, this.previousFilterText);
                }
            }
        }
    };

    TableViewController.prototype.mouseExitRow = function (e) {
        if (this.hoveredClassTimeout) {
            clearTimeout(this.hoveredClassTimeout);
            this.hoveredClassTimeout = null;
        }
        if (this.hoverClass) {
            var rowId = e.lpEventData.rowId;
            var rowData = this.rowIdToModel[rowId];
            if (rowData.view) {
                this.removeClass(rowData.view, this.hoverClass);
            }
        }

        this.clearSelection();
    };

    TableViewController.prototype.mouseEnterRow = function (e) {
        var rowId = e.lpEventData.rowId;

        if (this.selectedRowIndex >= 0 || this.selectedSectionIndex >= 0) {
            this.clearSelection();
        }

        var rowData = this.rowIdToModel[rowId];
        if (rowData.view) {
            if (this.hoverClass) {
                var that = this;
                this.hoveredClassTimeout = setTimeout(function () {
                    that.addClass(rowData.view, that.hoverClass);
                    that.hoveredClassTimeout = null;
                }, 20);
                return;
            }

            this.selectRow(rowData, false);
            this.selectedRowIndex = rowData.viewRowIndex;
            this.selectedRowViewID = rowData.view.id;
            this.selectedSectionIndex = rowData.viewSectionIndex;

            if (this.lineHighlightedCallback) {
                this.lineHighlightedCallback.call(this.context, rowData.rowData);
            }

            if (this.dataBinder && typeof this.dataBinder.rowHovered === 'function') {
                this.dataBinder.rowHovered.call(this.context, rowData.rowData);
            }
        }
    };

    TableViewController.prototype.selectRow = function (rowData, notifyListener) {
        this.clearSelection();
        this.selectedRowIndex = rowData.viewRowIndex;
        this.selectedRowViewID = rowData && rowData.view ? rowData.view.id : "";
        this.selectedSectionIndex = rowData.viewSectionIndex;
        if (this.rowSelectedCallback) {
            this.rowSelectedCallback.call(this.context, rowData);
        }

        if (this.dataBinder && typeof this.dataBinder.rowSelected === 'function' && notifyListener !== false) {
            this.dataBinder.rowSelected.call(this.context, rowData.rowData);
        }

        if (this.htmlTable) {
            this.addClass(rowData.view, this.LPClassesMap.selectedRow);
        } else {
            this.addClass(rowData.view.firstChild, this.LPClassesMap.selectedRow);
        }
    };

    TableViewController.prototype.selectRowByIndex = function (sectionIndex, rowIndex) {
        this.clearSelection();
        this.selectedSectionIndex = sectionIndex;
        this.selectedRowIndex = rowIndex;
        this.refreshSelected(false);
    };

    TableViewController.prototype.createRow = function (sectionView, context, rowData, rowId) {
        var targetView;
        var rowView;

        if (context.rowsPlaceholder) {
            targetView = context.getFirstElement(context.rowsPlaceholder, sectionView);
        } else {
            targetView = sectionView;
        }

        if (rowData) {
            rowData.detailsTooltip = rowData.detailsTooltip || "";
            rowData.details = rowData.details || "";
            rowData.text = rowData.text || "";
            rowData.rowId = rowId;
            rowData.rowPrefix = context.rowPrefix;

            var preInjectedTemplate = context.injectTextDefaults(context.rowTemplate, rowData);

            if (context.htmlTable) {
                rowView = preInjectedTemplate;
                if (!this.ignoreRowHover) {
                    setTimeout(function () {
                        var rowView = context.getFirstElement("#" + rowId);
                        context.bindViewEvent({view:rowView, DOMEvent:"mouseout", callback:context.mouseExitRow, lpEventData:{rowId:rowId}});
                        context.bindViewEvent({view:rowView, DOMEvent:"mouseover", callback:context.mouseEnterRow, lpEventData:{rowId:rowId}});
                    }, 0);
                }
            } else {
                rowView = context.createView({
                    template: preInjectedTemplate,
                    styleFile: context.rowStyleFile,
                    className: context.rowPrefix,
                    elementId: rowId,
                    target: targetView
                });

                if (!this.ignoreRowHover) {
                    this.bindViewEvent({view:rowView, DOMEvent:"mouseout", callback:this.mouseExitRow, lpEventData:{rowId:rowId}});
                    this.bindViewEvent({view:rowView, DOMEvent:"mouseover", callback:this.mouseEnterRow, lpEventData:{rowId:rowId}});
                }
            }

            if (!this.htmlTable && context.rowIdToModel[rowId]) {
                context.rowIdToModel[rowId].view = rowView;
            }
        }

        if (this.dataBinder && this.dataBinder.rowInitialized) {
            var that = this;
            setTimeout(function () {
                that.dataBinder.rowInitialized.call(that.context, context.rowIdToModel[rowId]);
            }, 0);
        }
        return rowView;
    };

    TableViewController.prototype.shouldFilterRow = function (data, filterText, keys) {
        if (!data || filterText == "undefined" || !keys) {
            return false;
        }
        keys = keys.constructor === Array ? keys : [keys];
        var lowerFilterText = filterText.toString().toLowerCase();
        for (var i = 0; i < keys.length; i++) {
            if (data[keys[i]] && data[keys[i]].toString().toLowerCase() === lowerFilterText) {
                return false;
            }
        }
        var splitFilterText = lowerFilterText.split(' ');
        for (var filterTextIndex = 0; filterTextIndex < splitFilterText.length; filterTextIndex++) {
            var keepRow = false;
            for (var keysArrayIndex = 0; keysArrayIndex < keys.length && !keepRow; keysArrayIndex++) {
                if (data[keys[keysArrayIndex]] && data[keys[keysArrayIndex]].toString().toLowerCase().indexOf(splitFilterText[filterTextIndex]) !== -1) {
                    keepRow = true;
                }
            }
            if (!keepRow) {
                return true;
            }
        }
        return false;
    };

    TableViewController.prototype.getSectionOwnerId = function (sectionData) {
        var sectionOwnerId;
        if (sectionData && typeof sectionData[this.sectionOwnerIdTag] !== "undefined") {
            sectionOwnerId = sectionData[this.sectionOwnerIdTag];
        }
        return sectionOwnerId;
    };
    /**
     * Return the table sections state
     * openSectionsIds - which section are open
     * openSectionsFilterIds - on filter which section are open
     * isFilterInit - is filter is after initialize
     * @returns {{openSectionsIds: *, openSectionsFilterIds: *, isFilterInit: *}}
     */
    TableViewController.prototype.getTableSectionsState = function () {
        var tableState = {
            openSectionsIds: lpUtils.cloneObject(this.openSectionsIds),
            openSectionsFilterIds: lpUtils.cloneObject(this.openSectionsFilterIds),
            isFilterInit: lpUtils.cloneObject(this.isFilterInit)
        };
        return tableState;
    };
    /**
     * Set the table sections state
     * @param tableState - Object:
     *      openSectionsIds - which section are open
     *      openSectionsFilterIds - on filter which section are open
     *      isFilterInit - is filter is after initialize
     * @param forbiddenModelChanged - Whether to forbidden modelChanged or not (default: false)
     */
    TableViewController.prototype.setTableSectionsState = function (tableState, forbiddenModelChanged) {
        this.openSectionsIds = typeof tableState.openSectionsIds === 'object' ? lpUtils.cloneObject(tableState.openSectionsIds) : this.openSectionsIds;
        this.openSectionsFilterIds = typeof tableState.openSectionsFilterIds === 'object' ? lpUtils.cloneObject(tableState.openSectionsFilterIds) : this.openSectionsFilterIds;
        this.isFilterInit = typeof tableState.isFilterInit === 'boolean' ? lpUtils.cloneObject(tableState.isFilterInit) : this.isFilterInit;
        if (!forbiddenModelChanged) {
            this.modelChanged();
        }
    };
    /**
     * Set the table sections state and update the model data
     * @param modelData - model date
     * @param tableState - the table state from getTableSectionsState
     */
    TableViewController.prototype.updateTableSectionsStateModelData = function (modelData, tableState) {
        this.setTableSectionsState(tableState, true);
        this.updateModelData(modelData);
    };

    return TableViewController;

});
